/* tslint:disable */
/* eslint-disable */
/**
 * API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../../common/runtime';
/**
 *
 * @export
 * @interface WorkerPatchRequest
 */
export interface WorkerPatchRequest {
  /**
   * Try fix a hung worker
   * @type {string}
   * @memberof WorkerPatchRequest
   */
  action?: WorkerPatchRequestActionEnum;
}

/**
 * @export
 */
export const WorkerPatchRequestActionEnum = {
  Heal: 'heal',
} as const;
export type WorkerPatchRequestActionEnum =
  (typeof WorkerPatchRequestActionEnum)[keyof typeof WorkerPatchRequestActionEnum];

/**
 * Check if a given object implements the WorkerPatchRequest interface.
 */
export function instanceOfWorkerPatchRequest(
  value: object,
): value is WorkerPatchRequest {
  return true;
}

export function WorkerPatchRequestFromJSON(json: any): WorkerPatchRequest {
  return WorkerPatchRequestFromJSONTyped(json, false);
}

export function WorkerPatchRequestFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): WorkerPatchRequest {
  if (json == null) {
    return json;
  }
  return {
    action: json['action'] == null ? undefined : json['action'],
  };
}

export function WorkerPatchRequestToJSON(
  value?: WorkerPatchRequest | null,
): any {
  if (value == null) {
    return value;
  }
  return {
    action: value['action'],
  };
}
